import {FormikProps} from 'formik';
import {ChangeEvent} from 'react';
import {IDirectDocsForm} from './formDetails';
import InputField from '../../../../../components/simpleInput';

interface IProps {
  form: FormikProps<IDirectDocsForm>;
}

const UserPhoneNumberInput = ({form}: IProps) => {
  return (
    <>
      <span className="mt-1 font-medium text-gray-800 text-md">
        اطلاعات پایه
      </span>

      <InputField
        name="userPhoneNumber"
        label="شماره موبایل کاربر"
        required
        disabled
        value={form.values.userPhoneNumber || ''}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          form?.setFieldValue('userPhoneNumber', e.target.value);
        }}
      />
    </>
  );
};

export default UserPhoneNumberInput;
